<!-- @format -->

<template>
	<el-switch
		v-model="value"
		:style="{
			'--el-switch-on-color': pcProps.activeColor,
			'--el-switch-off-color': pcProps.inactiveColor,
		}"
	/>
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';

	interface Props {
		modelValue: boolean;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: false,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
